<template>
  <div class="schoolChoose" :class="{ inApp: $root.$data.isApp}">
    <common-title  titleName="1对1择校" :bcColor="'#FFEFE7'" :isAPPShow="true" :zIndex="100" />
    <div class="content">
      <div class="top-head" :class="{isMini:isMiniProgram }">
        <div class="title">
          <div class="title-text">
            <h1>预约1对1择校</h1>
            <h3>择校择专业问题咨询</h3>
          </div>
          <img class="zxbg" src="../../assets/img/majorSenior/bg2.png" alt="" />
        </div>
      </div>
      <!-- 表单 -->
      <van-form @submit="onSubmit" :class="{ hasSubmit: isSubmit }">
        <div class="baseInfo"><span></span>基础信息</div>
        <van-field
          v-model="username"
          name="username"
          label="姓名"
          required
          placeholder="请输入"
          autocomplete="off"
          :rules="[
            { required: true, message: '请填写姓名' },
            { pattern: /^.{0,20}$/, required: true, message: '限制20个字符' },
          ]"
        />
        <van-field
          v-model="tel"
          type="tel"
          name="tel"
          label="联系电话"
          required
          placeholder="请输入"
          autocomplete="off"
          :rules="[{ pattern, required: true, message: '请填写正确的联系电话' }]"
        />

        <van-field class="noBackground" required name="radio1" label="是否二战">
          <template #input>
            <van-radio-group v-model="radio1" direction="horizontal">
              <van-radio checked-color="#FF7F41" name="1">是</van-radio>
              <van-radio checked-color="#FF7F41" name="0">否</van-radio>
            </van-radio-group>
          </template>
        </van-field>

        <van-field
          class="benkeyuanxiao"
          v-model="school"
          required
          name="school"
          label="本科院校"
          placeholder="请输入"
          autocomplete="off"
          :rules="[{ required: true, message: '请填写本科院校' }]"
          @click.native="arousePopupShow(1)"
        />
        <van-field
          readonly
          clickable
          label="本科专业"
          required
          name="major1"
          :value="major1"
          class="benkeyuanxiao"
          placeholder="请输入"
          @click="showPicker = true"
          autocomplete="off"
          is-link
          arrow-direction="down"
          :rules="[{ required: true, message: '请填写本科专业' }]"
        />
        <van-popup v-model="showPicker" round position="bottom">
          <van-picker
            show-toolbar
            :columns="majorData"
            @cancel="showPicker = false"
            @confirm="onConfirm"
          />
        </van-popup>

        <van-field
          v-model="levelfour"
          name="levelfour"
          label="四级分数"
          placeholder="请输入"
          autocomplete="off"
        />
        <van-field
          v-model="levelsix"
          name="levelsix"
          label="六级分数"
          placeholder="请输入"
          autocomplete="off"
        />
        <div class="baseInfo"><span></span>目标信息</div>
        <van-field class="noBackground" required name="radio2" label="院校档次">
          <template #input>
            <van-radio-group v-model="radio2" direction="horizontal">
              <van-radio checked-color="#FF7F41" name="0">985</van-radio>
              <van-radio checked-color="#FF7F41" name="1">211</van-radio>
              <van-radio checked-color="#FF7F41" name="2">其他</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <van-field
          readonly
          name="major2"
          clickable
          label="目标专业"
          required
          :value="major2"
          class="benkeyuanxiao"
          placeholder="请输入"
          @click="showPicker2 = true"
          autocomplete="off"
          is-link
          arrow-direction="down"
          :rules="[{ required: true, message: '请填写目标专业' }]"
        />
        <van-popup v-model="showPicker2" round position="bottom">
          <van-picker
            show-toolbar
            :columns="majorData"
            @cancel="showPicker2 = false"
            @confirm="onConfirm2"
          />
        </van-popup>

        <van-field class="noBackground" required name="radio3" label="硕士分类">
          <template #input>
            <van-radio-group v-model="radio3" direction="horizontal">
              <van-radio checked-color="#FF7F41" name="1">学硕</van-radio>
              <van-radio checked-color="#FF7F41" name="0">专硕</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <van-field class="noBackground" required name="radio4" label="是否全日制">
          <template #input>
            <van-radio-group v-model="radio4" direction="horizontal">
              <van-radio checked-color="#FF7F41" name="1">全日制</van-radio>
              <van-radio checked-color="#FF7F41" name="0">非全日制</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <van-field
          v-model="messageBoard"
          rows="2"
          name="messageBoard"
          label="特殊说明"
          type="textarea"
          maxlength="500"
          placeholder="请输入留言"
          autocomplete="off"
          show-word-limit
        />

        <div class="bottomBtn">
          <van-button color="#FF7F41" round block type="info" native-type="submit"
            >提交(剩余{{ timeCount }}次)</van-button
          >
          <p>提交后我们将在5个工作日内联系您</p>
        </div>
      </van-form>
    </div>
    <PopupSelect
      v-if="showPopup"
      :type="selectType"
      @closePopup="showPopup = false"
      @selectInfo="selectInfo"
    />
    <Loading ref="load" />
  </div>
</template>
<script>
import _ from 'lodash';
import { getMatchmajorApi, postAcademyinfoApi, getAcademyinfodetailApi } from '@/api/archives';
import CommonTitle from '@/components/header/CommonTitle.vue';
import PopupSelect from './components/popupSelect.vue';
import Loading from '@/components/loading/loading.vue';
import { whatEev } from '@/utils/tools';

export default {
  data() {
    return {
      isMiniProgram: false,
      pattern: /^[1][3-9]\d{9}$/,
      timeCount: 0,
      isSubmit: false,
      username: '', //姓名
      tel: '', //手机号
      radio1: '', //是否二战
      radio2: '', //院校档次
      radio3: '', //硕士分类
      radio4: '', //是否全日制
      school: '', //本科院校
      major1: '', //本科专业
      major2: '', //目标专业
      levelfour: '', //四级分数
      levelsix: '', //六级分数
      messageBoard: '', //特殊说明
      majorData: [],
      showPopup: false, // 选择院校弹窗
      selectType: 1, // 1 本科学校 2 专业 3 目标学校

      showPicker: false,
      showPicker2: false,
    };
  },
  components: {
    CommonTitle,
    PopupSelect,
    Loading,
  },
  watch: {},
  computed: {},
  created() {
    if (whatEev() === 'miniprogram') {
      this.isMiniProgram = true;
    }
  },
  mounted() {
    this.getDetail();
    this.getmatchMajor();
  },

  methods: {
    //获取表单数据
    async getDetail() {
      const res = await getAcademyinfodetailApi();
      if (res.code === 0 && res.data) {
        const {
          realName,
          contactsPhone,
          beAgain,
          tgSchoolLevel,
          tgSchoolType,
          fullTimeType,
          ugCollege,
          ugSubject,
          beTgSubject,
          beCet4Score,
          beCet6Score,
          academyRemark,
          status,
          createTime,
        } = res.data;
        if (status === 0) {
          //已提交未服务
          this.$router.replace({
            path: '/schoolChoose/submit',
            query: { timeSubmit: createTime },
          });
        } else if (status === 1) {
          //已服务
          this.$router.replace({
            path: '/schoolChoose/finished',
          });
        }
        // this.isSubmit = true;
        // this.timeCount = 0;
        // this.username = realName;
        // this.tel = contactsPhone;
        // this.radio1 = beAgain.toString();
        // this.radio2 = tgSchoolLevel.toString();
        // this.radio3 = tgSchoolType.toString();
        // this.radio4 = fullTimeType.toString();
        // this.school = ugCollege;
        // this.major1 = ugSubject;
        // this.major2 = beTgSubject;
        // this.levelfour = beCet4Score;
        // this.levelsix = beCet6Score;
        // this.messageBoard = academyRemark;
      } else {
        //未填写
        this.isSubmit = false;
        this.timeCount = 1;
      }
    },
    //所有专业
    async getmatchMajor() {
      const res = await getMatchmajorApi();
      let majorData = res.data;
      this.majorData = this.majorList(majorData);
    },

    majorList(data) {
      const textArr = ['categoryName', 'subjectName', 'majorName'];
      const children = ['subjectRespVOList', 'majorRespVOList'];
      function init(data) {
        const dataTemp = data.slice();
        return dataTemp.map((item) => {
          const obj = {};
          Object.keys(item).forEach((key) => {
            if (textArr.includes(key)) {
              obj.text = item[key];
            } else if (children.includes(key)) {
              obj.children = init(item[key]);
            } else {
              obj[key] = item[key];
            }
          });
          return obj;
        });
      }
      return init(data);
    },

    arousePopupShow(type) {
      this.selectType = type;
      this.showPopup = true;
    },
    //本科院校
    selectInfo(value) {
      this.school = value;
    },
    //本科专业
    onConfirm(value) {
      this.major1 = value.join('-');
      this.showPicker = false;
    },
    //目标专业
    onConfirm2(value) {
      this.major2 = value.join('-');
      this.showPicker2 = false;
    },
    //表单提交
    async onSubmit(values) {
      if (values.radio1 == '') {
        this.$toast('请选择是否二战');
        return;
      }
      if (values.radio2 == '') {
        this.$toast('请选择院校档次');
        return;
      }
      if (values.radio3 == '') {
        this.$toast('请选择硕士分类');
        return;
      }
      if (values.radio4 == '') {
        this.$toast('请选择是否全日制');
        return;
      }
      this.$refs.load.show = true;
      const {
        messageBoard,
        radio1,
        levelfour,
        levelsix,
        major2,
        tel,
        radio4,
        username,
        radio2,
        radio3,
        school,
        major1,
      } = values;
      const params = {
        academyRemark: messageBoard,
        beAgain: +radio1,
        beCet4Score: levelfour,
        beCet6Score: levelsix,
        beTgSubject: major2,
        contactsPhone: tel,
        fullTimeType: +radio4,
        realName: username,
        tgSchoolLevel: +radio2,
        tgSchoolType: +radio3,
        ugCollege: school,
        ugSubject: major1,
      };
      let result = await postAcademyinfoApi(params);
      if (result.data?.code === 0) {
        //成功
        this.$router.replace({
          path: '/schoolChoose/submit',
          query: { timeSubmit: result.data?.currentTime },
        });
      } else {
        this.$toast(result.data.msg);
      }
      this.$refs.load.show = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.schoolChoose {
  height: 100%;
  background-color: #f7f8fc;
  padding-bottom: 130px;
  .top-head {
    width: 100%;
    height: 350px;
    background: #ffefe7;
    .title {
      position: relative;
      width: 100%;
      height: 100%;
      .title-text {
        position: absolute;
        bottom: 60px;
        left: 100px;
        h1 {
          font-size: 40px;
          color: #ff7f41;
        }
        h3 {
          font-size: 30px;
          color: #333333;
          margin-top: 30px;
        }
      }
      .zxbg {
        position: absolute;
        right: 0;
        bottom: 0;
        width: 339px;
        height: 212px;
      }
    }
  }
  .isMini{
    height: 250px;
  }
  ::v-deep {
    .hasSubmit {
      pointer-events: none;
      .van-button {
        background: #3b363659 !important;
        border: none;
      }
    }
    .van-form {
      margin: 20px 0;

      .baseInfo {
        display: flex;
        align-items: center;
        font-size: 16px;
        font-weight: 500;
        color: #333333;
        margin-bottom: 10px;
        span {
          width: 3px;
          height: 16px;
          display: block;
          background-color: #ff7f41;
          border-radius: 4px;
          margin-right: 10px;
        }
      }
      .van-cell {
        background-color: transparent;
        width: 93%;
        margin: 0 20px;
        &::after {
          border: none;
        }
        .van-field__label {
          width: 5em;
          margin-right: 6px;
        }
        .van-cell__right-icon {
          background: white;
          height: 100%;
          line-height: 32px;
          margin-left: 0px;
          padding-right: 10px;
        }
      }
      .van-field__body {
        background-color: #fff;
        padding: 4px;
        border-radius: 4px;
        input {
          padding-left: 6px;
        }
      }
      .noBackground {
        .van-field__body {
          background-color: transparent;
        }
      }
      .benkeyuanxiao{
        input{
          pointer-events: none;
        }
      }
    }
    .van-ellipsis {
      white-space: wrap;
    }
  }

  .bottomBtn {
    width: 100%;
    background-color: #fff;
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    padding: 24px 36px;
    // margin: 16px;
    p {
      font-size: 22px;
      font-weight: 400;
      color: #999999;
      text-align: center;
      margin-top: 10px;
    }
  }
}
.inApp {
  padding-top: 0;
}
</style>
